import VueFeedback from '@ui-common/vue-feedback';

export default {
	components: {
		VueFeedback
	},
	props: {
		version: {
			required: true,
			type: Number
		}
	},
	methods: {
		scrollToRegistrationForm() {
			const registrationForm = document.getElementById('babyloan-registration-form');
			registrationForm && registrationForm.scrollIntoView(registrationForm);
		}
	}
};
